import Model from "../Model";

class BackCompany extends Model{

    buildUrl ({ param }) {
        return ['company', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BackCompany;